import React, {useEffect, useState} from "react";
import {makeStyles, Grid} from "@material-ui/core";
import Plano from "./Plano";
import CarouselPlanos from './CarouselPlanos';
import CarouselPlanosM from './CarouselPlanosM';
import api from '../service/api'

export default function Planos() {
  const classes = useStyles();
  const [planos, setPlanos] = useState([])

  useEffect(() => {
    api
      .get("/plans/active")
      .then((response) => setPlanos(Array.isArray(response.data.data) ? response.data.data : []))
      .catch(e => console.log("Erro ao buscar planos:", e.message));
  }, []);

  const quantPlanos = planos.length

  return(
    <div className={classes.root}>
      <div className={classes.desktop}>
        {
          planos?(
            quantPlanos <= 3 ?(
              <Grid container 
                className={classes.container}
                xs={12}
              >
                { planos?.map((plano, index) => (
                  <Grid item xs={4} key={plano?.id || index}>
                    <div className={classes.item}>
                      <Plano data={plano}/>
                    </div>
                  </Grid>
                ))}
              </Grid>
            ):( 
              <CarouselPlanos getPlanos = {planos}/>
            )
          ):('')
        }
      </div>
      <div className={classes.carouselM}>
        {
          planos?(<CarouselPlanosM planos = {planos}/>):('')
        }
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    width:"100vw",
    display: "flex",
  },
  container: {
    justifyContent: "space-evenly",
    marginTop: "28px",
    width: "100%",
    maxWidth: "1366px",
    alignItems: "center",
    display: "flex",
  },
  desktop: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  carouselM: {
    width: "100%",
    maxWidth: "1366px",
    paddingRight: "5px",
    paddingLeft: "5px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  item: {
    height:"100%",
    width:"100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));
